// ===========================================
// HOOK: useProrrogaForm
// ===========================================
// Hook TanStack Form para crear prórroga fiscal

import { useForm } from '@tanstack/react-form'
import { prorrogaSchema, type ProrrogaFormValues } from './prorrogaSchema'

interface UseProrrogaFormOptions {
  onSubmit?: (value: ProrrogaFormValues) => Promise<void>
  defaultValues?: Partial<ProrrogaFormValues>
}

export function useProrrogaForm(options: UseProrrogaFormOptions = {}) {
  const form = useForm({
    defaultValues: {
      impuesto_id: '',
      periodo: '',
      terminacion_cuit: null,
      fecha_original: '',
      fecha_nueva: '',
      motivo: '',
      fuente: null,
      referencia: null,
      ...options.defaultValues,
    } as ProrrogaFormValues,
    validators: {
      onSubmit: prorrogaSchema,
    },
    onSubmit: async ({ value }) => {
      if (options.onSubmit) {
        await options.onSubmit(value)
      }
    },
  })

  return { form }
}

export type UseProrrogaFormReturn = ReturnType<typeof useProrrogaForm>
export type ProrrogaForm = UseProrrogaFormReturn['form']
